module.exports = __webpack_public_path__ + "img/Gallery_2_05.bc212c1a.jpeg";